// extracted by mini-css-extract-plugin
module.exports = {"resourceChart":"resourceChart_resourceChart-d_ugV","clickable":"resourceChart_clickable-3mrpM"};